export default "ui-views{display:block}ui-views.form-content{background:#fff;padding:20px}\n";